import {combine, sample} from 'effector';
import i18next from 'i18next';
import {toast} from 'react-toastify';

import {RestError, showRestError} from 'core/errors';
import {history} from 'core/history';
import {ROUTE} from 'core/routes';

import {file$, fileChanged, setLastCreatedDocumentId} from '../index';

import {data$} from './tables/childrenCodes';

import {
    aggregationForm$,
    aggregationFormChanged,
    AggregationGate,
    createAggregationDocument,
    sendAggregationFx,
    step$,
    stepChanged,
} from './index';

aggregationForm$
    .on(aggregationFormChanged, (state, payload) => ({...state, ...payload}))
    .reset(AggregationGate.close);
step$.on(stepChanged, (_, payload) => payload).reset(AggregationGate.close);

sample({
    clock: createAggregationDocument,
    source: combine({
        form: aggregationForm$,
        codes: data$.map((p) => p.map((d) => d.identityCode)),
        file: file$,
    }),
    fn: ({form, codes, file}) => ({
        ...form,
        ...(codes.length && {codes}),
        ...(file && {file}),
    }),
    target: sendAggregationFx,
});

sendAggregationFx.fail.watch(({error}) => showRestError(error as RestError));

sendAggregationFx.done.watch((data) => {
    history.push(ROUTE.DOCUMENTS_DOCUMENTS);
    fileChanged(null);

    const id = data.result?.data?.data?.reportId || '';
    setLastCreatedDocumentId(id);
    toast.success(i18next.t('pages.documents.form.documentCreated', {number: id}), {
        className: 'Toastify__toast__wide',
    });
});
